<template>
  <div class="main-company-info">
    <div class="title-wrapper">
      <h2 v-html="companyInfo.topMessage"></h2>
    </div>
    <div class="img-wrapper">
      <img :src="companyInfo.mainImage.uri" :alt="companyInfo.mainImage.alt">
    </div>
    <div class="company-main-info-container">
      <div class="logo-wrapper">
        <img :src="companyInfo.logoImage.uri" :alt="companyInfo.logoImage.alt">
      </div>
      <article>
        <p class="company-name">{{ companyInfo.companyName }}</p>
        <section>
          <dt>業界：</dt>
          <dl>{{ companyInfo.industry }}</dl>
        </section>
        <section>
          <dt>事業内容：</dt>
          <dl>
            {{ companyInfo.businessContent }}
          </dl>
        </section>
        <section>
          <dt>従業員数：</dt>
          <dl>{{ companyInfo.employeeNumber }}</dl>
        </section>
      </article>
    </div>
    <article class="introduction-article">
      {{ companyInfo.introduction }}
    </article>
  </div>
</template>

<script>
export default {
  props: {
    company: {
      type: String,
    },
  },
  data () {
    // 定数名はパス名（社名）と一致させること
    const kinoshitanokaigo = {
      topMessage: "人事が定時で帰れるシステム（自動化・代行化）",
      mainImage: {
        uri: require("@/assets/lp/kinoshitanokaigo.png"),
        alt: "採用効率化における活用事例（株式会社木下の介護）"
      },
      logoImage: {
        uri: require("@/assets/lp/logo_kinoshita-kaigo.png"),
        alt: "採用効率化における活用事例（株式会社木下の介護）"
      },
      companyName: "木下グループ",
      industry: "医療介護",
      businessContent: "介護付き有料老人ホーム、住宅型有料老人ホーム、サービス付き高齢者向け住宅、グループホーム、デイサービスセンター、ショートステイ、訪問介護、居宅介護支援",
      employeeNumber: "4,750名（2019年3月時点）",
      introduction: "1都３県を中心に130施設超の介護施設を運営する【木下グループ】。「木下の介護」は、木下グループの傘下にあり、有料老人ホームやサービス付き高齢者向け住宅を運営。の介護保険制度施行（2000年4月1日）より前の、1995年から、民間企業の先駆けとして介護事業に参入。皆様の『幸せ』を実現するため、「おいしい食事による幸せ」「快適に住まう幸せ」「健康でいられる幸せ」「楽しく生活できる幸せ」「介護の質による幸せ」に積極取組中。"
    }
    const medicalcareservice = {
      topMessage: "外国人採用の一次対応やスクリーニングをロボにより自動化",
      mainImage: {
        uri: require("@/assets/lp/medicalcareservice.png"),
        alt: "メディカル・ケア・サービス画像"
      },
      logoImage: {
        uri: require("@/assets/lp/mcs_logo.jpg"),
        alt: "メディカル・ケア・サービスロゴ"
      },
      companyName: "メディカル・ケア・サービス株式会社",
      industry: "医療介護",
      businessContent: "グループホーム、介護付有料老人ホーム、住宅型有料老人ホーム、小規模多機能型居宅介護、都市型軽費老人ホーム、デイサービス、居宅介護支援サービス、福祉用具販売",
      employeeNumber: "6,000名（連結）",
      introduction: "メディカル・ケア・サービスでは、全国300箇所以上の介護施設・事業所を展開しています。地域に根ざしたグループホームとして、住心地の良い街づくりを実現しています。2017年には、グループホームの運営居室数が日本一になりました。2018年には学研ホールディングスのグループ会社となり、教育という大きな資産を介護の現場に導入することが可能になりました。今後も「人と人とのつながり」を大切に「夢の実現」に向け取り組んでまいります。"
    }
    return {
      // パスを変数名化
      companyInfo: eval(this.company)
    }
  }
}
</script>

<style scoped lang="scss">
.main-company-info {
  padding: 40px 80px;
  .title-wrapper {
    width: fit-content;
  }
  .company-main-info-container {
    display: flex;
    align-items: center;
    margin-top: 40px;
    article {
      .company-name {
        margin-bottom: 16px;
        font-weight: bold;
      }
      section {
        display: flex;
        dt {
          width: 80px;
          word-break: keep-all;
        }
      }
    }
  }
  .img-wrapper {
    width: 100%;
    max-width: 800px;
    margin: auto;
    margin-top: 40px;
    text-align: center;
  }
  .logo-wrapper {
    margin-right: 40px;
    img {
      width: 160px;
    }
  }
  .introduction-article {
    margin-top: 40px;
  }
}

@media screen and (max-width: 896px) {
  .main-company-info {
    .company-main-info-container {
      flex-direction: column;
      align-items: flex-start;
    }
    .logo-wrapper {
      margin-right: 0;
      margin-bottom: 16px;
    img {
      width: 120px;
    }
    }
  }
  .main-company-info {
    padding: 40px;
  }
}

@media screen and (max-width: 480px) {
  .main-company-info {
    padding: 24px 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/organisms/MainCompanyInfo.vue